<template>
  <div class="create-wrap">
    <van-cell-group>
      <van-field
        clearable
        required
        label="维修项目"
        type="text"
        placeholder="请输入维修项目"
        v-model="repaireName">
      </van-field>
      <van-field
        clearable
        required
        label="校区"
        type="text"
        right-icon="arrow"
        placeholder="请选择所属校区"
        :value="schoolDistrict"
        disabled
        @click="showSchoolPop">
      </van-field>
      <van-field
        clearable
        required
        label="场馆楼"
        type="text"
        right-icon="arrow"
        placeholder="请选择所属场馆楼"
        :value="building"
        disabled
        @click="showBuildingPop">
      </van-field>
      <van-field
        clearable
        required
        label="场室"
        type="text"
        right-icon="arrow"
        placeholder="请选择场室"
        :value="room"
        disabled
        @click="showRoomPop">
      </van-field>
      <van-field
        clearable
        required
        label="备注"
        type="text"
        placeholder="请输入备注"
        v-model="remark">
      </van-field>
    </van-cell-group>
    <PopList @chooseItem="selectSchool" :showState="isShowSchoolPop" :dataList="schoolDistrictList" @closePop="isShowSchoolPop = false"></PopList>
    <PopList @chooseItem="selectBuilding" :showState="isShowBuildingPop" :dataList="buildingList" @closePop="isShowBuildingPop = false"></PopList>
    <PopList @chooseItem="selectRoom" :showState="isShowRoomPop" :dataList="roomList" @closePop="isShowRoomPop = false"></PopList>
    <SingleBottomBtn @clickBtn="postVerify">提 交</SingleBottomBtn>
  </div>
</template>
<script>
  import SingleBottomBtn from '@/components/SingleBottomBtn.vue'
  import PopList from '../../components/PopList.vue'

  export default {
    name: 'StudentLeaveSubCreate',
    components: {
      SingleBottomBtn,
      PopList
    },
    data() {
      return {
        isShowSchoolPop: false,
        isShowBuildingPop: false,
        isShowRoomPop: false,

        repaireName: '',
        schoolDistrict: '',
        schoolDistrictId: '',
        building:'',
        buildingId:'',
        room: '',
        roomId: '',

        remark: '',
        schoolDistrictList: [],
        buildingList: [],
        roomList: [],
      }
    },
    created() {

    },
    mounted() {
      this.getSchoolDistrict()
    },
    computed: {},
    methods: {
      selectSchool(item) {
        this.schoolDistrict = item.label;
        this.schoolDistrictId = item.value;
        this.building = '';
        this.buildingId = '';
        this.room = '';
        this.roomId = '';
        this.isShowSchoolPop = false;
        this.getBuildingList()
      },
      selectBuilding(item) {
        this.building = item.label;
        this.buildingId = item.value;
        this.room = '';
        this.roomId = '';
        this.isShowBuildingPop = false;
        this.getRoomList()
      },
      selectRoom(item) {
        this.room = item.label;
        this.roomId = item.value;
        this.isShowRoomPop = false;
      },

      showSchoolPop() {
        this.isShowSchoolPop = true;
      },
      showBuildingPop() {
        if(!this.schoolDistrictId) {
          this.xy.msgError('暂无场馆楼')
          return;
        }
        this.isShowBuildingPop = true;
      },
      showRoomPop() {
        if(!this.buildingId) {
          this.xy.msgError('暂无场室')
          return;
        }
        this.isShowRoomPop = true;
      },

      postVerify() {
        if(!this.repaireName) {
          this.xy.msgError('请填写维修项目')
          return null;
        }
        if(!this.roomId) {
          this.xy.msgError('请填写场室')
          return null;
        }
        if(!this.remark) {
          this.xy.msgError('备注')
          return null;
        }
        this.postApproval();

      },
      async getSchoolDistrict() {
        let res = await this.xyapi.get(this.xyMApi + '/xy/comm/SchoolDistrictList')
        if (res.success) {
          this.schoolDistrictList = res.data.map((value) => {
            return {
              label: value.SchoolDistrictName,
              value: value.SchoolDistrictID,
            }
          })
        }
      },
      async getBuildingList() {
        let params = {
          schoolid: this.schoolDistrictId
        }
        let res = await this.xyapi.get(this.xyMApi + '/xy/comm/GetBuildingList', params)
        if (res.success) {
          this.buildingList = res.data.map((value) => {
            return {
              label: value.BuildingName,
              value: value.BuildingID,
            }
          })
        }
      },
      async getRoomList() {
        let params = {
          buildingID: this.buildingId
        }
        let res = await this.xyapi.get(this.xyMApi + '/xy/comm/GetHouseList', params)
        if (res.success) {
          this.roomList = res.data.map((value) => {
            return {
              label: value.HouseName,
              value: value.HouseID,
            }
          })
        }
      },
      async postApproval() {
          let params = {
            repairName: this.repaireName,
            houseID: this.roomId,
            remarks: this.remark
          }
          let res = await this.xyapi.post(this.$store.state.apiPath + '/api/ApplyRepair/Create', params)
          if (res.success) {
           this.xy.msgSuc('创建成功');
           this.$router.back();
          }
        },
      },
  }
</script>
<style lang="less" scoped>
  .create-wrap {
    font-size: 28px;
  }
</style>
